import React, { useEffect, useState } from 'react';
import { toast } from 'react-semantic-toasts';
import { captureException } from '@playbookux/playbook-web-core';
import { shape, string } from 'prop-types';
import { useMutation } from '@apollo/client';
import {
  Container, Divider, ElementForm, ErrorMessage, Input, MessageContainer, SaveButton, Section, Title,
} from '../../styles';
import {
  FIRST_NAME_LENGTH, LAST_NAME_LENGTH, TOAST_ERROR_TIME, TOAST_SUCCESS_TIME,
} from '../../constants';
import { isNameLengthValid } from '../../utils';
import { UPDATE_PROFILE } from '../../../graphql';

const FormUpdateProfile = (props) => {
  const { currentUser, meId } = props;

  const [firstName, setFirstName] = useState(currentUser ? currentUser.user.profile.firstName : '');
  const [lastName, setLastName] = useState(currentUser ? currentUser.user.profile.lastName : '');

  const [updateProfile, { loading: profileLoading }] = useMutation(UPDATE_PROFILE);

  useEffect(() => {
    if (currentUser) {
      setFirstName(currentUser.user.profile.firstName);
      setLastName(currentUser.user.profile.lastName);
    }
  }, [currentUser]);

  const handleSaveUser = async () => {
    try {
      const result = await updateProfile(
        {
          variables: {
            userId: meId,
            attributes: {
              firstName,
              lastName,
            },
          },
        },
      );

      if (result.error && result.error.message) {
        toast({
          type: 'error',
          title: 'Error',
          description: 'Error while saving user.',
          time: TOAST_ERROR_TIME,
        });
      } else {
        toast({
          type: 'info',
          description: 'Your updates have been saved!',
          time: TOAST_SUCCESS_TIME,
        });
      }
    } catch (err) {
      captureException('UPDATE_PROFILE_ERROR', err);
      toast({
        type: 'error',
        title: 'Error',
        description: 'Error while saving user.',
        time: TOAST_ERROR_TIME,
      });
    }
  };

  return (
    <Container>
      <Section>
        <ElementForm>
          <Title>First name</Title>
          <Input
            value={firstName}
            onChange={(x, { value }) => setFirstName(value)}
            placeholder="Enter your first name"
            error={firstName.length > FIRST_NAME_LENGTH}
          />
          {(firstName.length > FIRST_NAME_LENGTH) && (
            <MessageContainer>
              <ErrorMessage>
                Must be less than 30 characters
              </ErrorMessage>
            </MessageContainer>
          )}
          <br />
          <Title>Last name</Title>
          <Input
            value={lastName}
            onChange={(x, { value }) => setLastName(value)}
            placeholder="Enter your last name"
            error={lastName.length > LAST_NAME_LENGTH}
          />
          {(lastName.length > LAST_NAME_LENGTH) && (
            <MessageContainer>
              <ErrorMessage>
                Must be less than 40 characters
              </ErrorMessage>
            </MessageContainer>
          )}
        </ElementForm>
        <br />
        <ElementForm>
          <SaveButton
            onClick={handleSaveUser}
            disabled={
              profileLoading || isNameLengthValid(firstName, FIRST_NAME_LENGTH) || isNameLengthValid(lastName, LAST_NAME_LENGTH)
            }
            loading={profileLoading}
          >
            Save
          </SaveButton>
        </ElementForm>
      </Section>
      <Divider />
    </Container>
  );
};

FormUpdateProfile.propTypes = {
  currentUser: shape({
    user: shape({
      profile: shape({
        firstName: string,
        lastName: string,
      }),
    }),
  }),
  meId: string.isRequired,
};

FormUpdateProfile.defaultProps = {
  currentUser: null,
};

export default FormUpdateProfile;
